module.exports = __webpack_public_path__ + "static/img/vip.a4d5c5ea.png";